import React from "react";
import {
  Button,
  EmptyModal,
  Select,
  Textarea,
} from "../../../../components/core";
import { Image } from "primereact/image";

export default function VerifyIdModal({
  open,
  onClose,
  onVerifyUser,
  onRejectUser,
  data,
  userAccountId,
  setVerifyMessage,
}) {
  const [newDate, setNewDate] = React.useState(new Date());
  const [userStatusComments, setUserStatusComments] = React.useState("");
  const [verifiedStatusComments, setVerifiedStatusComments] =
    React.useState("");
  return (
    <EmptyModal open={open} onClose={onClose}>
      <p className="font-bold text-lg text-center">ID VERIFICATION</p>
      <div className="flex gap-2 mt-4">
        <p className="my-auto">Full name:</p>
        <p>
          {data.firstName && data.lastName
            ? `${data.firstName} ${data.middleName} ${data.lastName} ${data.suffixName}`
            : ""}
        </p>
      </div>
      <div className="flex gap-2 mt-4">
        <p className="my-auto">Birthdate:</p>
        <p>{data.birthDate ? data.birthDate : " N / A"}</p>
      </div>
      <div className="flex gap-2 mt-4">
        <p className="my-auto">ID Type:</p>
        <p>{data.idType ? data.idType.idType : ""}</p>
      </div>
      <div className="flex gap-2 mt-4">
        <p className="my-auto">ID Number:</p>
        <p>{data ? data.idNumber : ""}</p>
      </div>
      <hr className="my-4"></hr>
      <div className="grid grid-cols-2 gap-4 mt-4 mx-20 mb-4">
        <p className="text-center">Your photo</p>
        <p className="text-center">You holding ID</p>
        <Image
          src={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id1.jpg?${newDate.getTime()}`}
          zoomSrc={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id1.jpg?${newDate.getTime()}`}
          alt="Image"
          // width="80"
          // height="60"
          imageClassName="w-60 h-44"
          className="m-auto border-8 border-stone-400"
          preview
        />
        <Image
          src={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id2.jpg?${newDate.getTime()}`}
          zoomSrc={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id2.jpg?${newDate.getTime()}`}
          alt="Image"
          imageClassName="w-60 h-44"
          className="m-auto border-8 border-stone-400"
          preview
        />
        <p className="text-center">ID Only(Front)</p>
        <p className="text-center">ID Only (Back)</p>
        <Image
          src={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id3.jpg?${newDate.getTime()}`}
          zoomSrc={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id3.jpg?${newDate.getTime()}`}
          alt="Image"
          imageClassName="w-60 h-44"
          className="m-auto border-8 border-stone-400"
          preview
        />
        <Image
          src={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id4.jpg?${newDate.getTime()}`}
          zoomSrc={`https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id4.jpg?${newDate.getTime()}`}
          alt="Image"
          imageClassName="w-60 h-44"
          className="m-auto border-8 border-stone-400"
          preview
        />
      </div>
      <div className="mt-4">
        <p className="my-auto">Msg to User(Sent via SMS/APP):</p>
        <Textarea
          maxLength={1000}
          value={userStatusComments}
          onChange={(e) => {
            setVerifyMessage((prev) => ({
              ...prev,
              msgToUser: e.target.value,
            }));
            setUserStatusComments(e.target.value);
          }}
        />
        <p className="my-auto">Private Comments/Reason:</p>
        <Textarea
          maxLength={1000}
          value={verifiedStatusComments}
          onChange={(e) => {
            setVerifyMessage((prev) => ({
              ...prev,
              privateComment: e.target.value,
            }));
            setVerifiedStatusComments(e.target.value);
          }}
        />
      </div>
      <div className="grid grid-cols-2 gap-2 mt-4">
        <Button
          className="p-2"
          value="Reject"
          onClick={() =>
            onRejectUser(userStatusComments, verifiedStatusComments)
          }
        />
        <Button
          className="p-2"
          value="Accept"
          onClick={() =>
            onVerifyUser(userStatusComments, verifiedStatusComments)
          }
        />
      </div>
    </EmptyModal>
  );
}
